import React from 'react';

import styles from './LayerPopup.scss';
import classNames from 'classnames/bind';

import {Link} from 'react-router-dom';

// import Adsense23055 from 'components/adsense/Adsense23055';

const cx = classNames.bind(styles);

const ItemObject = ({
  itemSeq, name, img, key
}) => {
  return (
    <Link to={`/item/${itemSeq}`} key={key}>
      <li className={cx("recent-box__item")}>
        <div className={cx("recent-box__thumb")}>
          <img src={img} alt={name} />
        </div>
        <span className={cx("recent-box__name")}>{name}</span>
      </li>
    </Link>
  )
}

const LayerPopup = ({itemLayerPopInfo, popupClose}) => {
  const {lstItemList, openYn} = itemLayerPopInfo;

  const list = lstItemList.length === 0 ? [] : lstItemList.map((_obj, cnt) => {
    if(_obj != null) {
        const {ITEM_SEQ, ITEM_NM, IMG_SRC} = _obj;
      return (
        <ItemObject itemSeq={ITEM_SEQ} name={ITEM_NM} img={IMG_SRC}/>
      )
    }else{
      return [];
    }
  })

  return (
    <aside className={cx("recent-box", openYn == 'Y' && "is-open")}>
      <div className={cx("recent-box__header")}>
        <span className={cx("recent-box__title")}>최근 본 아이템</span>
        <button className={cx("recent-box__close")} onClick={popupClose}>×</button>
      </div>

      <ul className={cx("recent-box__list")}>
        {list}
      </ul>
    </aside>
  );
};

export default LayerPopup;